/* eslint-disable no-debugger */
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';
import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const getClubRegistrationRequirmentData = (state, setState) => {
    const api = initApi(API_NAMES.CLUB, state, setState);
    const url = `/UsasClub/registrationRequirements`;

    return api?.executeObject ? api.executeObject(url, 'GET') : null;
};

const ClubRegistrationRequirmentData = { 
  INITIAL_STATE: BASIC_INITIAL_STATE, 
  getClubRegistrationRequirmentData };

export default ClubRegistrationRequirmentData;